import { Controller } from "@hotwired/stimulus"

// data-controller="mobile-filter-btn"
export default class extends Controller {
  static targets = ["filterOverlay"]

  open() {
    this.filterOverlayTarget.classList.remove("hidden")
  }

  close() {
    this.filterOverlayTarget.classList.add("hidden")
  }
}
